export const CARDS_GATEWAY_PROVIDER_NAME = 'emburse_cards_gateway';
export const CARDS_GATEWAY_CARD_TYPE = 'corporate_card';
export const EMBURSE_CARDS_PROVIDER_NAME = 'emburse';
export const PROVIDER_VALUES = [
    'finicity',
    'plaid',
    'abacus',
    'capitalone',
    'emburse',
    'demo_data_provider',
    'manual_upload',
    CARDS_GATEWAY_PROVIDER_NAME
];
export var INSTITUTION_TYPE;
(function (INSTITUTION_TYPE) {
    INSTITUTION_TYPE["AMEX_CPG"] = "amex_cpg";
    INSTITUTION_TYPE["AMEX_CEL"] = "amex_cel";
    INSTITUTION_TYPE["AMEX_FINS"] = "amex_fins";
    INSTITUTION_TYPE["AMEX_FILES"] = "amex_files";
    INSTITUTION_TYPE["EMBURSE_DEMO"] = "emburse_demo";
    INSTITUTION_TYPE["GRINGOTTS"] = "gringotts";
    INSTITUTION_TYPE["EMBURSE"] = "emburse";
    INSTITUTION_TYPE["EMBURSE_PROD"] = "emburse_prod";
    INSTITUTION_TYPE["FINICITY"] = "finicity";
    INSTITUTION_TYPE["CAPITAL_ONE"] = "capital-one";
})(INSTITUTION_TYPE || (INSTITUTION_TYPE = {}));
export const EMBURSE_ISSUED_CARDS = [
    INSTITUTION_TYPE.EMBURSE,
    INSTITUTION_TYPE.EMBURSE_DEMO,
    INSTITUTION_TYPE.GRINGOTTS,
    INSTITUTION_TYPE.EMBURSE_PROD
];
